/* eslint-disable import/no-import-module-exports */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';

import Root from '@/components/Root';
import { makeStore } from '@/store';

const initialState = window.APP_INITIAL_STATE;
const locale = window.APP_LOCALE;
const routerBasename = window.APP_ROUTER_BASENAME;
const routerContext = window.APP_ROUTER_CONTEXT;

delete window.APP_INITIAL_STATE;
delete window.APP_LOCALE;
delete window.APP_ROUTER_BASENAME;
delete window.APP_ROUTER_CONTEXT;

const deployUrl = process.env.APP_DEPLOY_URL;
const currentOrigin = window.location.origin;

if (deployUrl === currentOrigin) {
  const store = makeStore({ initialStore: initialState });

  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);

  const render = (Component) => {
    root.render(
      <Component
        store={store}
        locale={locale}
        routerBasename={routerBasename}
        routerContext={routerContext}
        env="client"
      />
    );
  };

  loadableReady(() => {
    if (module.hot) {
      module.hot.accept('@/components/Root', async () => {
        const NextRoot = (await import('@/components/Root')).default;
        render(NextRoot);
      });
    }

    render(Root);
  });
}

export default currentOrigin;
